import { render, staticRenderFns } from "./ModalTamanhoQuadro.vue?vue&type=template&id=61e7a864&scoped=true"
var script = {}
import style0 from "./ModalTamanhoQuadro.vue?vue&type=style&index=0&id=61e7a864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7a864",
  null
  
)

export default component.exports